import { defineMessages } from 'react-intl';

export const loginMessages = defineMessages({
    welcomeBack: {
        id: 'login-welcome-back',
        defaultMessage: 'Welcome back',
    },
    loginMessage: {
        id: 'login-message',
        defaultMessage: 'Log in to your Billing account',
    },
    loginUsernameTip: {
        id: 'login-username-tip',
        defaultMessage: 'Use your username to login',
    },
    loginPasswordTip: {
        id: 'login-password-tip',
        defaultMessage: 'Use your password to login',
    },
    login: {
        id: 'login',
        defaultMessage: 'Login',
    },
});

export const forgotPasswordMessages = defineMessages({
    forgotPassword: {
        id: 'forgot-password',
        defaultMessage: 'Forgot your password?',
    },
});

export const commonMessages = defineMessages({
    username: {
        id: 'username',
        defaultMessage: 'Username',
    },
    usernamePlaceholder: {
        id: 'username-placeholder',
        defaultMessage: 'Username',
    },
    password: {
        id: 'password',
        defaultMessage: 'Password',
    },
    slideshowTitleStatistics: {
        id: 'slideshow-title-statistics',
        defaultMessage: 'Business critical statistics',
    },
    slideshowSubtitleStatistics: {
        id: 'slideshow-subtitle-statistics',
        defaultMessage: 'Discover the power of data with our intelligent statistics and widgets',
    },
});
